import React, { useEffect } from "react";
import LinksData from "../../data/links.json";
import LinkCategorySection from "../../components/LinkCategorySection/LinkCategorySection";
import "./LinksPage.css";

/// リンク集メインページ
const LinksPage: React.FC = () => {
  useEffect(() => {
    // ページ表示時にbodyクラスを追加
    document.body.classList.add("links-page-body");

    // クリーンアップ：ページ離脱時にbodyクラスを削除
    return () => {
      document.body.classList.remove("links-page-body");
    };
  }, []);

  /// カテゴリへのスムーススクロール処理（ヘッダーの高さを考慮）
  const scrollToCategory = (categoryId: string) => {
    const element = document.getElementById(`category-${categoryId}`);

    if (element) {
      // レスポンシブ対応：画面幅に応じてヘッダー高さを調整
      const screenWidth = window.innerWidth;
      let headerHeight: number;

      if (screenWidth <= 768) {
        headerHeight = 60; // SPヘッダー高さ
      } else {
        headerHeight = 104; // PCヘッダー高さ
      }

      // getBoundingClientRectで要素の絶対位置を取得
      const rect = element.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const elementTop = rect.top + scrollTop;

      const elementPosition = elementTop - headerHeight;

      window.scrollTo({
        top: Math.max(0, elementPosition), // ページ上部より上にはスクロールしない
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="links-page">
      <div className="container">
        <header className="page-header">
          <h1 className="page-title">
            <span className="title-icon">🔗</span>
            リンク集
          </h1>
          <p className="page-description">
            マール・アストレアに関連する様々なリンクをカテゴリ別にまとめました。
            <span className="desktop-break" />
            公式情報、ファンアート、切り抜き動画など、お探しのコンテンツをお楽しみください。
          </p>

          <nav className="category-navigation">
            {LinksData.categories.map((category) => (
              <button
                key={category.id}
                className="category-nav-button"
                onClick={() => scrollToCategory(category.id)}
                style={
                  {
                    "--category-color": category.color,
                  } as React.CSSProperties & { "--category-color": string }
                }
                aria-label={`${category.title}セクションにスクロール`}
              >
                <span className="nav-button-icon">{category.icon}</span>
                <span className="nav-button-text">{category.title}</span>
              </button>
            ))}
          </nav>
        </header>

        <div className="categories-container">
          {LinksData.categories.map((category) => (
            <LinkCategorySection key={category.id} category={category} />
          ))}
        </div>

        <footer className="page-footer">
          <p className="footer-note">
            リンク先の内容について、当サイトは責任を負いかねます。
          </p>
          <p className="footer-update">最終更新: 2025年6月</p>
        </footer>
      </div>
    </div>
  );
};

export default LinksPage;
